import React from 'react';
import PropTypes from 'prop-types';
import './AboutUs.css';
import collegeLogo from './../../assets/logo.jpg';
import { Card } from "reactstrap";


const AboutUs = () => (
 
  <div className='container'>
  
      <h3 className='text-center' style={{ color: '#123fae', backgroundColor:'#a2a2a208' }} >ABOUT US</h3>
  <div className="college-info">
  <div className="container">
   
    <div>
      {/* First Section */}
      
      <div >
        <div className="info-header">
          <h3 style={{ color: '#123fae' }}>About Guru Jambheshwar University of Science & Technology</h3>
        </div>
        <div>
          <p style={{textAlign:'justify' }}>
          The Guru Jambheshwar University of Science & Technology, Hisar is a State University established on October 20, 1995, by an Act of the Legislature of the State of Haryana to facilitate and promote studies and research in emerging areas of higher education with a focus on new frontiers of technology, pharmacy, environmental studies, non-conventional sources energy and management studies and also to achieve excellence in these and connected fields. It was formally inaugurated on November 1, 1995. It is named after Guru Jambheshwar Ji Maharaj, a saint environmentalist of the 15th century.
           </p>
        
          <p style={{textAlign:'justify' }}>
          The University has been recognized by the University Grants Commission (UGC) under Section 2(f) for recognition of degrees on 11.1.1996 and under section 12(B) of the UGC Act to be eligible for central assistance on 7.2.1997. The University has been accredited 'A' Grade by National Assessment and Accreditation Council (NAAC) in 2002 and has been re-accredited as grade 'A' with (CGPA 3.26) in 2009. Thereafter, the University has also been re-accredited third time as 'A' Grade with (CGPA 3.28) by National Assessment and Accreditation Council (NAAC), Bangalore for a period of five years from 10.12.2014 to 09.12.2019 and further extended for two years i.e., upto 09.12.2021. At present, the University is A+ Grade NAAC accredited University from 18.10.2022 to 17.10.2027 with a CGPA of 3.38 in the fourth cycle of accreditation. </p>
        
          {/* <p>
          Centre for Distance and Online Education, GJUS&T Hisar started 17 online job-ready certificate courses, designed to develop learners to take up specific industry roles in various sectors of the economy. After successful completion of these courses, learners will gain the skill knowledge and shall be able to start working either as entrepreneurs or apply for positions in different organizations where there is a requirement for the related posts as per the courses.</p>
         */}
        </div>
      </div>
    </div>
    {/* Second Section */}
    
    {/* Third Section */}
    <div className="row align-items-center">
     

      <div >
        <div className="info-header">
          <h3 style={{ color: '#123fae' }}>About Center for Distance and Online Education, GJU</h3>
        </div>
        <div >
          <p style={{textAlign:'justify'}}>
           The Directorate of Distance Education of this University was established in 1997 with four programmes namely; MBA, PGDCA, BBA & CIC. Since then a lot of progress has been made in terms of number of programmes, number of students enrolled, production of quality Self-Learning Material (SLM) etc. Not only the new programmes were added, but some of the Programmes were replaced by the new ones so as to make them highly job-oriented and enable the students to pursue them while being in job and self-employment. At present, 3 undergraduate, 06 post-graduate programmes and 05 Diploma/Certificate Programmes in Open and Distance Learning Mode are being offered and the learning is imparted directly by the Directorate. For the admitted students, the directorate organizes Personal Contact Programmes (PCPs) during which the teachers of parent departments and the programme co-coordinators hold classes and satisfy the queries of the students. There is also well equipped Computer Lab for students with internet connection. The study material has been prepared by the Directorate with the association of specialists in the respective areas and the same is updated as and when the changes are brought about in the programme curriculum as per needs of the market. In order to have the interest of the students closely watched, the Directorate has appointed teachers/programme coordinators in the respective disciplines for each programme. Notwithstanding the moderate amount of fee charged for each programme, the students have the facility to pay the same in half yearly installments so that the students with limited financial resources can also afford to acquire quality education. In addition to it, the students of distance education get the benefit of Post Matric Scholarship (PMS) released by the Government of Haryana. From the session 2015-16 onwards, the on-line admission process was adopted to facilitate the student spread all over India and abroad. The Directorate is at present offering 16 job oriented programmes including MBA and B.Com (Online Mode) entitled by DEB (UGC) and approved by the University in Open and Distance Learning Mode. </p>
        </div>
      </div>

      <div >
        <div className="info-header">
          <h3 style={{ color: '#123fae' }}>About Haryana Knowledge Corporation Limited (HKCL)</h3>
        </div>
        <div >
          <p style={{textAlign:'justify'}}>
            Haryana Knowledge Corporation Limited (HKCL) is an organization promoted by the Government of Haryana, to create a new paradigm in education and development through the universalization and integration of Information Technology in teaching, learning, and educational management processes, and socio-economic transformative processes in general.
          </p>
        </div>
      </div>
    </div>
    
    {/* Merged Vision and Mission Section */}
    {/* <div className="row align-items-center merged-section" style={{ backgroundColor: '#f4f9ff', color: 'black', padding: '20px', borderRadius: '10px' }}>
      <div className="col-md-12">
        <div className="info-header vision-header text-align-left" style={{ color: 'blue' }}>
          <h4 style={{ textAlign: 'left' }}>Vision:</h4>
        </div>
        <div className="info-text text-justify">
          <p style={{textAlign:'justify'}}>
            To be the premier destination for individuals seeking to develop essential skills and knowledge necessary to thrive in the 21st-century workforce, fostering a community of empowered learners poised for success in diverse career pathways.
          </p>
        </div>
      </div>



      <div className="col-md-12">
        <div className="info-header mission-header text-align-left" style={{ color: 'blue' }}>
          <h4 style={{ textAlign: 'left' }}>Mission:</h4>
        </div>
        <div className="info-text text-justify">
          <p style={{textAlign:'justify'}}>
            Centre for Development of Skills & Knowledge (DeSK) is committed to providing innovative, career-oriented courses through 21st Century Job Readiness Courses. Our mission is to equip learners with the knowledge-based skills, social competencies, and growth mindset essential for success in today's dynamic job market. By offering a diverse range of courses mapped to specific industry roles, we aim to empower individuals from Punjab State to excel as competent professionals and entrepreneurs, contributing to the economic growth and prosperity of the region. Through our comprehensive and flexible e-learning platform, we strive to create an inclusive learning environment where every learner can unlock their full potential and embark on a journey of lifelong learning and career advancement.
          </p>
        </div>
      </div>
    </div> */}

  </div>
</div>

</div>

);

AboutUs.propTypes = {};

AboutUs.defaultProps = {};

export default AboutUs;
